import { OTP_EXPIRY_MINUTES, OTP_LENGTH, TOO_MANY_ATTEMPTS_MESSAGE } from '@/lib/constants';

export class AuthRateLimitError extends Error {
  readonly retryAfterSeconds: number;

  constructor(retryAfterSeconds: number) {
    super(TOO_MANY_ATTEMPTS_MESSAGE);
    this.name = 'AuthRateLimitError';
    this.retryAfterSeconds = retryAfterSeconds;
  }
}

export function parseRetryAfterSeconds(headerValue: string | null, now = Date.now()): number {
  if (!headerValue) return 0;
  const trimmed = headerValue.trim();
  if (trimmed.length === 0) return 0;
  if (/^\d+$/.test(trimmed)) return Number.parseInt(trimmed, 10);

  const dateMs = Date.parse(trimmed);
  if (Number.isNaN(dateMs)) return 0;
  return Math.max(0, Math.ceil((dateMs - now) / 1000));
}

export function withNewCodePrompt(message?: string): string {
  const text = message?.trim() || 'Invalid OTP';
  if (!/invalid or expired/i.test(text)) return text;
  if (/request a new code/i.test(text)) return text;
  return `${text.replace(/[. ]+$/, '')}. Request a new code.`;
}

export function verificationCodeInstructions(email: string): string {
  return `Check your email ${email} for a ${OTP_LENGTH}-character verification code. It expires in ${OTP_EXPIRY_MINUTES} minutes.`;
}

export function formatCountdown(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${minutes}:${String(remainder).padStart(2, '0')}`;
}

export function authSubmitLabel(
  rateLimitSeconds: number,
  loading: boolean,
  loadingLabel: string,
  idleLabel: string,
): string {
  if (rateLimitSeconds > 0) return `Try again in ${formatCountdown(rateLimitSeconds)}`;
  return loading ? loadingLabel : idleLabel;
}
